import React from 'react';
import { useRouter } from 'next/router';
import { GOOGLE_TAG_KEY } from '@/env';
import { LINK_CLICK, logEvent } from '@/utilities/analytics';
import { deviceType } from '@/utilities/device';
import { getUtmTags } from '@/utilities/utmTagsStore';
import { useLocale } from '@separate/hooks/translation';
import { compact } from '@separate/utilities/object';
import { useGetUrl } from './getUrl';
import { useCurrentUser } from './user';

export function useRouterChangeAnalytics() {
  const router = useRouter();
  React.useEffect(() => {
    if(!GOOGLE_TAG_KEY) return true;

    const routerChangeAnalytics = (url) => {
      window.dataLayer.push({
        event: "content-view",
        "content-name": url,
        "content-view-name": router.asPath,
        pageTitle: document.title || ""
      });
    }
    router.events.on('routeChangeComplete', routerChangeAnalytics);
    return () => {
      router.events.off('routeChangeComplete', routerChangeAnalytics);
    };
  }, [router.events, router.asPath]);
}

export const useLogLinkClick = (props) => {
  const { href, position, activity, step, type, isExternal } = props;
  const { user } = useCurrentUser();
  const locale = useLocale();
  const { rootUrl, canonicalUrl, localePath } = useGetUrl();

  const destinationUrl = isExternal ? href : `${rootUrl}${localePath}${href}`;

  const logLinkClick = React.useCallback(() => {
    logEvent(LINK_CLICK, compact({
      source: 'web',
      pid: user?.pid,
      utm_parameters: getUtmTags(),
      device_type: deviceType(),
      language: locale,
      source_url: canonicalUrl,
      destination_url: destinationUrl,
      position,
      activity,
      step,
      type,
    }));
  }, [activity, canonicalUrl, destinationUrl, locale, position, step, type, user]);

  return { logLinkClick };
};
